import { render, staticRenderFns } from "./changeAcceptanceStatus.vue?vue&type=template&id=5fbf9dc0"
import script from "./changeAcceptanceStatus.vue?vue&type=script&lang=js"
export * from "./changeAcceptanceStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports